<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Calendar'"
            [description]="'View and manage Atoku bookings.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">

            <div class="calendar-shell" fxLayout="column">
                <div class="calendar-topbar" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <span class="heading-default calendar-title-spacer" aria-hidden="true">Calendar</span>

                    <ng-container *ngIf="displayMode === 'calendar'; else tableNav">
                        <div class="calendar-nav" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
                            <div class="nav-group" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                <button mat-icon-button (click)="previousMonth()">
                                    <mat-icon>keyboard_double_arrow_left</mat-icon>
                                </button>
                                <button mat-icon-button (click)="previous()">
                                    <mat-icon>chevron_left</mat-icon>
                                </button>
                            </div>
                            <div class="nav-center" fxLayout="column" fxLayoutAlign="center center">
                                <span class="view-subtitle">{{ currentDate | date:'MMMM y' }}</span>
                            </div>
                            <div class="nav-group" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                <button mat-icon-button (click)="next()">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                                <button mat-icon-button (click)="nextMonth()">
                                    <mat-icon>keyboard_double_arrow_right</mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #tableNav>
                        <div class="calendar-nav" aria-hidden="true"></div>
                    </ng-template>

                    <div class="calendar-view-controls" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="12px">
                        <mat-button-toggle-group class="calendar-toggle-group"
                            [value]="displayMode" (change)="onDisplayModeChange($event.value)"
                            hideSingleSelectionIndicator>
                            <mat-button-toggle value="calendar">Calendar</mat-button-toggle>
                            <mat-button-toggle value="table">Table</mat-button-toggle>
                        </mat-button-toggle-group>

                        <mat-button-toggle-group class="calendar-toggle-group" [value]="viewFilter"
                            (change)="viewFilter = $event.value; onViewFilterChange()" hideSingleSelectionIndicator>
                            <mat-button-toggle value="bookings">Bookings</mat-button-toggle>
                            <mat-button-toggle value="storage">Storage</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>

                <ng-container *ngIf="displayMode === 'calendar'; else tableView">
                <div class="calendar-grid">
                    <div class="left-panel" fxLayout="column">
                        <div class="filters-panel" fxLayout="column" fxLayoutGap="12px">
                            <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always">
                                <mat-label>{{ viewFilter === 'storage' ? 'Search Storage' : 'Search Stations' }}</mat-label>
                                <input matInput (keyup)="onSearchChange($event)"
                                    [placeholder]="viewFilter === 'storage' ? 'Search by storage name...' : 'Search by station name...'">
                                <mat-icon matSuffix color="primary">search</mat-icon>
                            </mat-form-field>

                            <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always"
                                *ngIf="viewFilter !== 'storage'">
                                <mat-label>Category</mat-label>
                                <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange()">
                                    <mat-option *ngFor="let category of categories" [value]="category">{{ category }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always"
                                *ngIf="viewFilter !== 'storage'">
                                <mat-label>Equipment</mat-label>
                                <mat-select [(value)]="selectedEquipment" (selectionChange)="onEquipmentChange()">
                                    <mat-option value="">All equipment</mat-option>
                                    <mat-option *ngFor="let equip of availableEquipment" [value]="equip">{{ equip }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always"
                                *ngIf="viewFilter === 'storage'">
                                <mat-label>Storage Type</mat-label>
                                <mat-select [(value)]="selectedStorageType" (selectionChange)="onStorageTypeChange()">
                                    <mat-option *ngFor="let type of storageTypes" [value]="type">{{ type }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <ng-container *ngIf="viewFilter !== 'storage'; else storageList">
                            <div class="station-row" *ngFor="let station of filteredStations; let rowIndex = index"
                                [class.alt-row]="rowIndex % 2 === 1">{{ station.name }}</div>
                        </ng-container>
                        <ng-template #storageList>
                            <div class="station-row" *ngFor="let storage of filteredStorageUnits; let rowIndex = index"
                                [class.alt-row]="rowIndex % 2 === 1">{{ storage.name }}</div>
                        </ng-template>
                    </div>

                    <div class="middle-panel">
                        <div class="day-headers">
                            <div class="day-header-cell" *ngFor="let day of weekDays" [class.is-today]="isToday(day)">
                                <div class="day-label">{{ day | date:'EEE' }}</div>
                                <div class="day-date">{{ day | date:'d MMM' }}</div>
                            </div>
                        </div>
                        <div class="alignment-row"></div>
                        <ng-container *ngIf="viewFilter !== 'storage'; else storageRows">
                            <div class="day-row" *ngFor="let station of filteredStations; let rowIndex = index"
                                [class.alt-row]="rowIndex % 2 === 1">
                                <div class="day-cell" *ngFor="let day of weekDays"
                                    [class.is-selected]="isSelectedCell(station, day)"
                                    (click)="selectCell(station, day)">
                                    <ng-container *ngIf="getRowValue(station, day) as value">
                                        <span class="booking-pill" *ngIf="value > 0"
                                            [ngClass]="getBookingPillClass(getRowUtilization(station, day))">
                                            {{ value }}
                                        </span>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #storageRows>
                            <div class="day-row" *ngFor="let storage of filteredStorageUnits; let rowIndex = index"
                                [class.alt-row]="rowIndex % 2 === 1">
                                <div class="day-cell" *ngFor="let day of weekDays"
                                    [class.is-selected]="isSelectedCell(storage, day)"
                                    (click)="selectStorageCell(storage, day)">
                                    <ng-container *ngIf="getRowValue(storage, day) as value">
                                        <span class="booking-pill" *ngIf="value > 0"
                                            [ngClass]="getBookingPillClass(getRowUtilization(storage, day))">
                                            {{ value }}
                                        </span>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-template>
                    </div>

                    <div class="right-panel" [class.storage-view]="viewFilter === 'storage'">
                        <ng-container *ngIf="viewFilter !== 'storage'; else storagePanel">
                            <div class="details-header" *ngIf="selectedStation && selectedDate; else noSelection">
                                {{ selectedDate | date:'EEE, d MMM' }}: {{ selectedStation.name }}
                            </div>
                            <ng-template #noSelection>
                                <div class="details-header">Select a station and day</div>
                            </ng-template>

                            <div class="details-list">
                                <div class="details-row" *ngFor="let item of getSelectedHourItems()"
                                    [class.is-empty]="!item.isBooked"
                                    [class.is-selecting]="item.isSelectedRange"
                                    [class.is-selection-start]="item.isSelectionStart"
                                    [class.is-selection-end]="item.isSelectionEnd"
                                    (click)="onHourSlotClick(item)">
                                    <div class="details-hour">{{ item.hour }}:00</div>
                                    <div class="details-booking">
                                        <ng-container *ngIf="selectedStation && selectedDate; else emptyRow">
                                            <ng-container *ngIf="item.booking; else availableRow">
                                                <div class="details-booking-block"
                                                    [class.is-start]="item.isStart"
                                                    [class.is-end]="item.isEnd"
                                                    [class.is-middle]="item.isBooked && !item.isStart && !item.isEnd">
                                                    <ng-container *ngIf="item.isStart; else blankRow">
                                                        <div class="details-user">{{ getBookingDurationLabel(item.booking) }}</div>
                                                        <div class="details-time">{{ getBookingTimeRange(item.booking) }}</div>
                                                        <div class="details-equipment" *ngFor="let line of getBookingEquipmentLines(item.booking)">
                                                            {{ line }}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #availableRow>
                                            <div class="details-booking-item available-hour">
                                                {{ item.isSelectedRange ? 'Selected' : 'Available' }}
                                            </div>
                                        </ng-template>
                                        <ng-template #blankRow>
                                            <div class="details-booking-item">&nbsp;</div>
                                        </ng-template>
                                        <ng-template #emptyRow>
                                            <div class="details-booking-item">-</div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #storagePanel>
                            <div class="details-header" *ngIf="selectedStorage && selectedDate; else storageEmpty">
                                {{ selectedDate | date:'EEE, d MMM' }}: {{ selectedStorage.name }}
                            </div>
                            <ng-template #storageEmpty>
                                <div class="details-header">Select storage and day</div>
                            </ng-template>

                            <div class="details-search">
                                <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always">
                                    <mat-label>Search Users</mat-label>
                                    <input matInput (keyup)="onStorageSearchChange($event)" placeholder="Search by user name...">
                                    <mat-icon matSuffix color="primary">search</mat-icon>
                                </mat-form-field>
                            </div>
                            <div class="details-available" *ngIf="selectedStorage && selectedDate">
                                Available: {{ getSelectedStorageAvailable() }}
                            </div>

                            <div class="details-list">
                                <div class="details-row" *ngFor="let booking of getSelectedStorageBookings()">
                                    <div class="details-booking">
                                        <div class="details-booking-block">
                                            <div class="details-storage-line">
                                                <span class="details-user">{{ booking.userName }}</span>
                                                <span class="body-1-regular-2">{{ booking.amount }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                </ng-container>

                <ng-template #tableView>
                    <div class="calendar-table-shell mat-elevation-z3 radius-10 crud-table-shell" fxLayout="column">
                        <div class="calendar-table-toolbar" fxLayout="row wrap" fxLayoutAlign="space-between center"
                            fxLayoutGap="16px">
                            <div fxLayout="column" fxLayoutGap="6px">
                                <span class="body-1-regular-2">
                                    {{ activeTableCount }} {{ activeTableCountLabel }}
                                </span>
                            </div>

                            <div class="calendar-table-filters" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="12px">
                                <ng-container *ngIf="viewFilter === 'bookings'; else storageTableFilters">
                                    <mat-form-field class="custom-text-field table-search-field" appearance="outline" floatLabel="always">
                                        <mat-label>Search Stations</mat-label>
                                        <input matInput (keyup)="onSearchChange($event)" placeholder="Search by station name...">
                                        <mat-icon matSuffix color="primary">search</mat-icon>
                                    </mat-form-field>

                                    <mat-form-field class="custom-select-field table-select-field" appearance="outline" floatLabel="always">
                                        <mat-label>Category</mat-label>
                                        <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange()">
                                            <mat-option *ngFor="let category of categories" [value]="category">{{ category }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="custom-select-field table-select-field" appearance="outline" floatLabel="always">
                                        <mat-label>Equipment</mat-label>
                                        <mat-select [(value)]="selectedEquipment" (selectionChange)="onEquipmentChange()">
                                            <mat-option value="">All equipment</mat-option>
                                            <mat-option *ngFor="let equip of availableEquipment" [value]="equip">{{ equip }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>

                                <ng-template #storageTableFilters>
                                    <mat-form-field class="custom-text-field table-search-field" appearance="outline" floatLabel="always">
                                        <mat-label>Search Storage</mat-label>
                                        <input matInput (keyup)="onSearchChange($event)" placeholder="Search by storage name...">
                                        <mat-icon matSuffix color="primary">search</mat-icon>
                                    </mat-form-field>

                                    <mat-form-field class="custom-select-field table-select-field" appearance="outline" floatLabel="always">
                                        <mat-label>Storage Type</mat-label>
                                        <mat-select [(value)]="selectedStorageType" (selectionChange)="onStorageTypeChange()">
                                            <mat-option *ngFor="let type of storageTypes" [value]="type">{{ type }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-template>
                            </div>
                        </div>

                        <app-crud-table
                            [displayColumns]="activeTableDisplayColumns"
                            [modelType]="calendarCrudTableModel"
                            [tableData]="activeTableData"
                            [title]="activeTableLabel"
                            [showReload]="false">
                        </app-crud-table>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>

    <div class="modal-backdrop" *ngIf="showBlockOutModal">
        <div class="blockout-modal">
            <div class="blockout-modal-header" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                    <div class="view-subtitle">Block out time</div>
                    <div class="body-1-regular-2" *ngIf="selectedDate">
                        {{ selectedDate | date:'EEE, d MMM' }} {{ formatHour(blockOutStartHour || 0) }}-{{ formatHour((blockOutEndHour || 0) + 1) }}
                    </div>
                </div>
                <button mat-icon-button type="button" (click)="closeBlockOutModal()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="blockout-modal-body" fxLayout="column" fxLayoutGap="14px">
                <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always">
                    <mat-label>Title</mat-label>
                    <input matInput [(ngModel)]="blockOutTitle">
                </mat-form-field>

                <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always">
                    <mat-label>Reason</mat-label>
                    <textarea matInput rows="3" [(ngModel)]="blockOutReason"></textarea>
                </mat-form-field>

                <div class="blockout-section" fxLayout="column" fxLayoutGap="8px">
                    <div class="body-1-default">Stations</div>
                    <div class="blockout-option-list">
                        <mat-checkbox *ngFor="let station of getBlockOutStationOptions()"
                            [checked]="isBlockOutStationSelected(station)"
                            (change)="toggleBlockOutStation(station, $event.checked)">
                            {{ station.name }}
                        </mat-checkbox>
                    </div>
                </div>

                <div class="blockout-section" fxLayout="column" fxLayoutGap="8px">
                    <div class="body-1-default">Equipment</div>
                    <div class="blockout-equipment-list">
                        <div class="blockout-equipment-row" *ngFor="let item of blockOutEquipment">
                            <div>
                                <div class="body-1-regular-1">{{ item.name }}</div>
                                <div class="body-1-regular-2">Available: {{ item.quantity }}</div>
                            </div>
                            <mat-form-field class="blockout-quantity-field custom-text-field" appearance="outline" floatLabel="always">
                                <mat-label>Qty</mat-label>
                                <input matInput type="number" min="0" [max]="item.quantity"
                                    [ngModel]="item.selectedQuantity"
                                    (ngModelChange)="updateBlockOutEquipmentQuantity(item, +$event)">
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="blockout-error" *ngIf="blockOutError">{{ blockOutError }}</div>
            </div>

            <div class="blockout-modal-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
                <button mat-button type="button" (click)="closeBlockOutModal()">Cancel</button>
                <button mat-flat-button color="primary" type="button" [disabled]="isSavingBlockOut" (click)="saveBlockOut()">
                    {{ isSavingBlockOut ? 'Saving...' : 'Block out' }}
                </button>
            </div>
        </div>
    </div>
</div>
